import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import API from '../../../config/API';
import { useAuthContext } from './useAuthContext';

export const useLogin = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { dispatch } = useAuthContext();
    const navigate = useNavigate();

    const login = async (phone_number, password) => {
        setIsLoading(true);
        setError(null);

        try {
            const res = await API.post('log_in', {
                password, phone_number
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            localStorage.setItem('user', JSON.stringify(res.data.details));
            dispatch({ type: 'LOGIN', payload: res.data.details });
            setIsLoading(false);
            return { success: true };
        } catch (err) {
            setIsLoading(false);
            const errorMessage = err?.response?.data?.message || 'Login failed. Please try again.';
            setError(errorMessage);
            console.log(err);
            return { success: false, error: errorMessage };
        }
    }

    return { login, isLoading, error, setError }
}